var $9be03138870991df$exports = {};
$9be03138870991df$exports = {
  "backButton": args => "Vissza ide: ".concat(args.prevMenuButton),
  "moreActions": "Tov\xE1bbi lehet\u0151s\xE9gek",
  "unavailable": "Nem \xE9rhet\u0151 el, a r\xE9szletek\xE9rt bontsa ki"
};
export { $9be03138870991df$exports as default };